import { render, staticRenderFns } from "./RemoteControl.vue?vue&type=template&id=025980f1&scoped=true&"
import script from "./RemoteControl.vue?vue&type=script&lang=js&"
export * from "./RemoteControl.vue?vue&type=script&lang=js&"
import style0 from "./RemoteControl.vue?vue&type=style&index=0&id=025980f1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025980f1",
  null
  
)

export default component.exports